import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import EventCollection from '~/glm/models/gds/event-collection';
import HeaderCell from '~/glm/components/guest-list/header/header-cell.jsx';
import GdsHouseholdCollection from '~/glm/models/gds/gds-household-collection';
import SortableHeaderCell from '~/glm/components/guest-list/sortable-header-cell';
import Checkbox from '~/glm/components/guest-list/checkbox';
import classNames from 'classnames';
import cellStyles from './guest-row.scss';
import headerStyles from './header-cell.scss';
import rowStyles from './row.scss';
import { Tooltip, TooltipContainer } from '@xo-union/tk-component-tooltips';
import Icon from '@xo-union/tk-component-icons';

const sortbyHousehold = sort => !sort.direction || sort.attribute === 'partyOf';
const householdGrouping = ({ filter, rsvpFilter, mealFilter, sort }) =>
  !filter && !rsvpFilter && !mealFilter && sortbyHousehold(sort);

const ContactTitleCell = () => {
  return (
    <HeaderCell name="Contact" className={classNames(cellStyles.contactInfo, 'text-center')}>
      <div className={headerStyles.tooltipContainer}>
        <TooltipContainer>
          <div data-testid="header-contact-tip" className={headerStyles.informationIcon}>
            <Icon name="info" size="sm" />
          </div>
          <Tooltip data-testid="header-contact-tooltip" arrowPosition="top" className={headerStyles.tooltip}>
            Send each guest on your list the link to their own unique address collection form to add or update their
            info.
          </Tooltip>
        </TooltipContainer>
      </div>
    </HeaderCell>
  );
};

@observer
class OverViewListColumns extends React.Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    gdsEvents: PropTypes.instanceOf(EventCollection).isRequired,
    gdsHouseholds: PropTypes.instanceOf(GdsHouseholdCollection),
    numberOfHouseholds: PropTypes.number,
    trackSelectAllGuests: PropTypes.func,
  };

  handleSelectionCellClick = () => {
    const { gdsUiState, trackSelectAllGuests } = this.props;
    const promises = [gdsUiState.toggleAllGuestsSelection()];
    if (!gdsUiState.allGuestsSelected) {
      promises.push(trackSelectAllGuests());
    }
    return Promise.all(promises);
  };

  renderHeaderSelectionCell = () => {
    const { gdsUiState } = this.props;
    return (
      <HeaderCell className={classNames(headerStyles.selectionCell)}>
        <Checkbox
          id="selectAllGuests"
          className={rowStyles.selectionCheckbox}
          checked={gdsUiState.allGuestsSelected}
          onClick={this.handleSelectionCellClick}
        />
      </HeaderCell>
    );
  };

  renderEventHeaderCells = () => {
    const { gdsEvents } = this.props;
    return gdsEvents.nonReceptionEvents.map(gdsEvent => {
      const { name, id } = gdsEvent;

      return <HeaderCell key={id} name={`${name} RSVP`} className={cellStyles.rsvp} id="glm-first-visit-1" />;
    });
  };

  render() {
    const { gdsUiState, numberOfHouseholds } = this.props;

    return (
      <>
        <tr className={rowStyles.headerRow}>
          {this.renderHeaderSelectionCell()}
          <SortableHeaderCell
            entity="guest"
            sortAttr="lastName"
            name="Name"
            className={cellStyles.name}
            numberOfHouseholds={numberOfHouseholds}
          />
          {householdGrouping(gdsUiState) && (
            <SortableHeaderCell
              entity="guest"
              sortAttr="partyOf"
              name="Party Of"
              className={cellStyles.partyOf}
              numberOfHouseholds={numberOfHouseholds}
            />
          )}
          <ContactTitleCell />
          {this.renderEventHeaderCells()}
          <HeaderCell name="My Notes" className={classNames(cellStyles.notes)} />
        </tr>
      </>
    );
  }
}

export default OverViewListColumns;
